{
  "RESET_PASSWORD": {
    "TITLE": "إعادة تعيين كلمة المرور",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "البريد الإلكتروني",
      "PLACEHOLDER": "الرجاء إدخال بريدك الإلكتروني.",
      "ERROR": "الرجاء إدخال بريد إلكتروني صالح."
    },
    "API": {
      "SUCCESS_MESSAGE": "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "SUBMIT": "إرسال"
  }
}
